import { EMPTY_STRING } from "shared/constants";
import { IFormInput } from "./types";

export const defaultValues: IFormInput = {
  approvalThroughId: null,
  additionalTerms: EMPTY_STRING,
  entries: [],
};
